import { ModalityLabel } from '@dynamika-shared/types/imagingLabels';
import _ from 'lodash';
import { VisitConfig } from '@dynamika-shared/types/visits';

export function getInputDataTypes(
  modalities: ModalityLabel[],
  target: VisitConfig
) {
  if (target.id === 'default') {
    return _.uniq(
      _.flatMap(modalities, modality => _.map(modality.labels, 'inputDataType'))
    );
  }

  return _.uniq(
    _.flatMap(target.labels, id =>
      _.flatMap(modalities, modality =>
        _.map(_.filter(modality.labels, { id }), 'inputDataType')
      )
    )
  );
}
